import React, { useEffect, useState } from "react";
import { AvatarGroup, Avatar, Table } from "flowbite-react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import CreateTroc from "../../components/modales/CreateTroc";
import { canIcreateTrocAsTrav, getExchangeElementsTrav, removeTrocOfTrav } from "../../services/callAPI/toTravelerTrocs";
import "./MyExchangeElements.css";
import { ErrorOccurred } from "../../services/utils/ErrorOccurred";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ValidToast from "../../components/toasts/ValidToast";
import UnvalidToast from "../../components/toasts/UnvalidToast";
import EditTroc from "../../components/modales/EditTroc";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { canIcreateTrocAsRes, getExchangeElementsOfRes, removeTrocOfRes } from "../../services/callAPI/toResidentsTrocs";
import { SpinnerC } from "../../components/spinners/SpinnerC";
import { useNavigate } from 'react-router-dom';
import IndicateServiceNeedName from "../../components/indicateSerNeedName/IndicateSerNeedName";

export type exchangeElementsOfTrav = {
  id: number,
  like_number: number,
  title: string,
  description: string,
  start_time: string,
  end_time: string,
  flexible: boolean,
  matchedNeeds: string[],
  matchedServices: string[],
  isAvailable: boolean,
  is_subject_of_request: boolean,
  departement?: string | null
}

export type exchangeElementsOfRes = {
  id: number,
  title: string,
  description: string,
  start_time: string,
  end_time: string,
  flexible: boolean,
  matchedNeeds: string[],
  matchedServices: string[],
  isAvailable: boolean,
  is_subject_of_proposal: boolean,
  departement: string | null;
}

/*///////////////////// main components /////////////////*/
function MyExchangeElements() {
  const [canCreateTroc, setCanCreateTroc] = useState<boolean>(false);

  const [triggerUseffect2, setTriggerUseEffect2] = useState<boolean>(false);

  const [exchangeElementslistOfTrav, setExchangeElementslistOfTrav] = useState<exchangeElementsOfTrav[]>();

  const [exchangeElementslistOfRes, setExchangeElementslistOfRes] = useState<exchangeElementsOfRes[]>();

  const [showErrorOccurred, setShowErrorOccurred] = useState<boolean>(false);

  const [isLoadingExchangeElements, setisLoadingExchangeElements] = useState<boolean | null>(null);

  //get user role via redux
  const userRole = useSelector((state: RootState) => state.user.role);

  async function isUserCanCreateTroc() {
    try {
      let canCreate: boolean | null = null;

      switch (userRole) {
        case "TRAVELER":
          canCreate = await canIcreateTrocAsTrav();
          break;
        case "RESIDENT":
          canCreate = await canIcreateTrocAsRes();
          break;
        default:
          canCreate = null;
          break;
      }

      if (canCreate !== null) {
        setCanCreateTroc(canCreate);
      }
    } catch (error) {
      //redirect to home page
      location.href = "/";
    }
  }

  function separateDateTime(dateTime: string) {
    const date = new Date(dateTime);

    const month = (date.getMonth() + 1).toString().padStart(2, "0"); //month

    const day = date.getDate().toString(); // Jour

    const year = date.getFullYear().toString().slice(-2);//year

    // Formater la date (par exemple : "06-12-24")
    const formattedDate = `${day}-${month}-${year}`;

    // Formater l'heure (par exemple : "09:51:00")
    const formattedTime = date.toISOString().split('T')[1].slice(0, 5); // Récupère uniquement l'heure (HH:mm)

    return { date: formattedDate, time: formattedTime };
  }

  //first useEffect to check if userCanCreateTroc to actived button create
  useEffect(() => {
    isUserCanCreateTroc();
  }, [triggerUseffect2]);

  //second useEffect to get exchangeElements
  useEffect(() => {
    //define loading exchangeElements
    setisLoadingExchangeElements(true);

    //call api
    const handleExchangeElements = async () => {
      try {
        let trocList = null;

        switch (userRole) {
          case "TRAVELER":
            trocList = await getExchangeElementsTrav();

            if (trocList && trocList.length > 0) {
              //formated dateTime
              trocList.map((troc: exchangeElementsOfTrav) => {
                //format startDateTime
                const { date: dateStart, time: timeStart } = separateDateTime(troc.start_time);

                troc.start_time = `${dateStart} ${timeStart}`;

                //format endDateTime
                const { date: dateEnd, time: timeEnd } = separateDateTime(troc.end_time);

                troc.end_time = `${dateEnd} ${timeEnd}`;
              });

              //redefine exchangeElementsListOfTrav
              setExchangeElementslistOfTrav(trocList);
            }
            else {//no troc        
              setExchangeElementslistOfTrav([]);
              setisLoadingExchangeElements(false);
            }

            break;
          case "RESIDENT":
            trocList = await getExchangeElementsOfRes();

            if (trocList && trocList.length > 0) {
              //formated dateTime
              trocList.map((troc: exchangeElementsOfRes) => {
                //format startDateTime
                const { date: dateStart, time: timeStart } = separateDateTime(troc.start_time);

                troc.start_time = `${dateStart} ${timeStart}`;

                //format endDateTime
                const { date: dateEnd, time: timeEnd } = separateDateTime(troc.end_time);

                troc.end_time = `${dateEnd} ${timeEnd}`;
              });

              //redefine exchangeElementsListOfRes
              setExchangeElementslistOfRes(trocList);
            }
            else {//no troc        
              setExchangeElementslistOfRes([]);
              setisLoadingExchangeElements(false);
            }
            break;
        }
      } catch (error) {
        //redifine exchangeElementslistOfTrav, exchangeElementslistOfRes and canCreateTroc state variables
        setExchangeElementslistOfTrav([]);

        setExchangeElementslistOfRes([]);
        setCanCreateTroc(false);

        //redefine showErrorOccurred
        setShowErrorOccurred(true);

        //redirect to home page after 3secondes
        const timer = setTimeout(() => {
          location.href = "/";
        }, 3000);

        // Nettoyer le timeout si le composant est démonté
        return () => clearTimeout(timer);
      }
    }
    handleExchangeElements()
  }, [triggerUseffect2]);

  if (exchangeElementslistOfTrav && exchangeElementslistOfTrav.length > 0 || exchangeElementslistOfRes && exchangeElementslistOfRes.length > 0) {
    return (
      <div className="flex flex-col gap-4 p-1">
        <CreateTroc userRole={userRole} canIcreateTroc={canCreateTroc} triggerUseffect2={triggerUseffect2} setTriggerUseEffect2={setTriggerUseEffect2} />

        <ExchangeElementsTable exchangeElementslistOfTrav={exchangeElementslistOfTrav} exchangeElementslistOfRes={exchangeElementslistOfRes} setTriggerUseEffect2={setTriggerUseEffect2} triggerUseEffect2={triggerUseffect2} />
      </div>
    )
  } else if (isLoadingExchangeElements) {
    return (
      <SpinnerC />
    )
  } else if (isLoadingExchangeElements === false) {
    return (
      <div className="flex flex-col gap-4 p-1">
        <CreateTroc userRole={userRole} canIcreateTroc={canCreateTroc} triggerUseffect2={triggerUseffect2} setTriggerUseEffect2={setTriggerUseEffect2} />

        <p>Tu n'as pas encore créé de paire de troc</p>
      </div>
    )
  } else {
    { showErrorOccurred && <ErrorOccurred message="Nous n'avons pas pû récupérer vos éléments d'échanges. Veuillez nous contacter afin de résoudre le problème ou rééssayer plus tard." /> }
  }

}
export default MyExchangeElements;

/*////////////////////// annexe components/////////////// */
function ExchangeElementsTable(props: { exchangeElementslistOfTrav?: exchangeElementsOfTrav[], exchangeElementslistOfRes?: exchangeElementsOfRes[], setTriggerUseEffect2: React.Dispatch<React.SetStateAction<boolean>>, triggerUseEffect2: boolean }) {
  const { exchangeElementslistOfTrav, exchangeElementslistOfRes, setTriggerUseEffect2, triggerUseEffect2 } = props;

  const [showValidToast, setshowValidToast] = useState<boolean>(false);

  const [showUnValidToast, setshowUnValidToast] = useState<boolean>(false);

  const [expandedRowIndex, setExpandedRowIndex] = useState<number | null>(null);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [hasLikesTrav, sethasLikesTrav] = useState<boolean | undefined>(undefined);
  const [serviceNeedName, setServiceNeedName] = useState<string>("");
  const [isIndicateServiceNeedName, setisIndicateServiceNeedName] = useState<boolean>(false);

  const navigate = useNavigate();

  //get user role via redux
  const userRole = useSelector((state: RootState) => state.user.role);

  // État pour stocker la valeur de colspan
  const [colspan, setColspan] = useState(3);

  // Fonction pour ajuster le colspan en fonction de la taille de l'écran
  const adjustColspan = () => {
    if (window.innerWidth <= 530) {
      setColspan(3); // Retour à colspan="3" 
    } else {
      setColspan(4); // Change à colspan="4"
    }
  };

  // Utilisation de useEffect pour gérer le redimensionnement de la fenêtre
  useEffect(() => {
    // Appeler la fonction lors du montage initial du composant
    adjustColspan();

    // Ajouter un écouteur d'événements pour redimensionner la fenêtre
    window.addEventListener('resize', adjustColspan);

    // Nettoyer l'écouteur d'événements lors du démontage du composant
    return () => {
      window.removeEventListener('resize', adjustColspan);
    };
  }, []); // Le tableau vide assure que cela ne s'exécute qu'une seule fois au montage


  //handleRemovingTroc
  async function handleRemovingTroc(trocId: number) {
    try {
      let status;
      switch (userRole) {
        case "TRAVELER":
          status = await removeTrocOfTrav(trocId);
          break;
        case "RESIDENT":
          status = await removeTrocOfRes(trocId);
          break;
        default:
          status = null;
      }

      if (status != 204) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        //show toast ok
        setshowValidToast(true);

        //update table
        setTriggerUseEffect2(!triggerUseEffect2)
      }
    } catch (error) {
      // show toast not ok
      setshowUnValidToast(true);
    }
  }

  function handleExpandedRow(index: number) {
    // Si la ligne est déjà étendue, la rétracter
    if (expandedRowIndex === index) {
      setExpandedRowIndex(null); // Rétracte la ligne
    } else {
      setExpandedRowIndex(index); // Étend la nouvelle ligne
    }
  }

  const handleClickToIndicateServNeedName = (serviceOrNeeedName: string) => {
    setServiceNeedName(serviceOrNeeedName);
    setisIndicateServiceNeedName(true);
  };

  //resize window
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (userRole === "TRAVELER") {
      const hasLikes = exchangeElementslistOfTrav?.some(item => item.like_number > 0);
      sethasLikesTrav(hasLikes);
    }
  });

  return (
    <>
      {/* show toast */}
      {showValidToast && <ValidToast onClose={() => setshowValidToast(false)} />}
      {showUnValidToast && <UnvalidToast onClose={() => setshowUnValidToast(false)} />}

      <div className="relative max-h-[calc(100vh-15rem)] overflow-y-auto shadow-md sm:rounded-lg">
        <Table className="w-full table-auto text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">

          {/* thead part */}
          <thead className=" bg-orangeCustom sticky top-0 text-white dark:bg-gray-700 dark:text-gray-400 text-sm sm:text-base lg:text-lg">
            <tr>
              {/*  return likes th col conditionally */}
              {userRole === "TRAVELER" && hasLikesTrav ?
                (
                  <th id="table-th-likes" scope="col" className="px-2 py-3 text-center rounded-tl-md">
                    LIKES RE&#199;US
                  </th>
                ) :
                null
              }
              <th id="table-th-title" scope="col" className={`px-2 py-3 text-center ${!hasLikesTrav ? "rounded-tl-md" : null}`}>
                TITRE
              </th>
              <th id="table-th-services" scope="col" className="px-2 py-3 text-center">
                MES SERVICES
              </th>
              <th id="table-th-needs" scope="col" className="px-2 py-3 text-center">
                MES BESOINS
              </th>
              <th id="table-th-date" scope="col" className="px-2 py-3 text-center">
                DUREE
              </th>
              <th id="table-th-last-empty" scope="col" className="px-2 py-3 rounded-tr-md">
                ACTIONS
                <span className="sr-only">Edit</span>
              </th>
            </tr>
          </thead>

          {/* tbody part */}
          <tbody className="text-sm sm:text-base lg:text-lg">

            {/* exchange element of trav */}
            {exchangeElementslistOfTrav?.map((item, index) => (
              <React.Fragment key={index}>
                <tr className={`text-black border-b-2 ${windowWidth >= 1000 ? 'hover:cursor-default' : " hover:cursor-pointer"} hover:bg-gradient-to-b hover:from-gray-200 hover:to-gray-100`} onClick={() => { handleExpandedRow(index) }}>

                  {/* return likes td col conditionally*/}
                  {userRole === "TRAVELER" && hasLikesTrav ?
                    (
                      <td id="td-likes" className="text-center max-w-2 max-h-2">
                        <div className="flex justify-center cursor-pointer">
                          <AvatarGroup>
                            {
                              item.like_number > 0 &&
                              Array.from({ length: Math.min(item.like_number, 5) }).map((_, index) => (
                                <Avatar key={index} rounded stacked size="xs" />
                              ))
                            }
                            {item.like_number > 0 &&
                              <div onClick={() => navigate(`/who-enjoyed-the-troc/${item.id}`)}>
                                <Avatar.Counter total={item.like_number} />
                              </div>
                            }
                          </AvatarGroup>
                        </div>
                      </td>
                    ) :
                    null
                  }

                  {/* title and pastille */}
                  <td id="td-tilte-pastille-t" className="text-center">
                    <div id="div-title-pastille-t" className="flex items-center">

                      {/* pastille green or red */}
                      {item.isAvailable === true ? (
                        <div className="rounded-full min-w-4 min-h-4 bg-greenCustom" title="Disponible"></div>
                      ) : <div className="rounded-full min-w-4 min-h-4 bg-lightRedCustom" title="Indisponible"></div>
                      }

                      <div className="flex-grow">
                        {item?.title}
                      </div>
                    </div>
                  </td>

                  {/* services */}
                  <td id="td-services" className="p-2">
                    <div className="flex gap-2 justify-center flex-wrap">
                      {item.matchedServices.map((service, index) =>
                        service ? (
                          <img
                            key={index}
                            className="h-16 w-16 cursor-pointer"
                            src={`${"/servicesDuNomade-besoinsDuRésident/" + service + ".png"}`}
                            alt="service"
                            onClick={() => handleClickToIndicateServNeedName(service)}
                          />
                        ) :
                          null
                      )}
                    </div>
                  </td>

                  {/* needs */}
                  <td id="td-needs">
                    <div className="flex justify-center gap-2 flex-wrap">
                      {item.matchedNeeds.map((need, index) =>
                        need ? (
                          <img
                            key={index}
                            className="h-16 w-16"
                            src={`${"/besoinsDuNomade-servicesDuRésident/" + need + ".png"}`}
                            alt="need"
                            onClick={() => handleClickToIndicateServNeedName(need)}
                          />
                        ) :
                          null
                      )}
                    </div>
                  </td>

                  {/* date */}
                  <td id="start-end-date-time" className="text-center font-normal">
                    {`Du ${item?.start_time}`}
                    <br />
                    au
                    <br />
                    {`${item?.end_time}`}
                  </td>

                  {/* actions */}
                  <td id="td-actions" className="text-center max-w-24 max-h-24 w-28">

                    <div id="container-icon-actions" className="w-full h-full">

                      {/* btn edit or delete */}
                      {item.isAvailable && item.is_subject_of_request === false ? (
                        <EditTroc userRole={userRole} troc={item} triggerUseffect2={triggerUseEffect2} setTriggerUseEffect2={setTriggerUseEffect2} />
                      ) : <button type="button" className="flex justify-center px-4 py-2 text-gray-700 hover:bg-gray-100" onClick={() => handleRemovingTroc(item.id)}>
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                      }

                    </div>

                  </td>

                </tr>

                {/* in mobile release: expanded row */}
                {/* part expanded row */}
                {expandedRowIndex === index && (
                  <tr id="tr-expanded-row-rlse-mob" className="hover:bg-gray-200 text-black border-b-2 ">
                    <td id="dynamic-td" colSpan={colspan}>

                      <div id="div-services-needs" className="flex flex-col gap-2">

                        {/* services */}
                        <div id="div-expanded-row-services" className="flex flex-col gap-2 items-center">

                          <p className="font-medium text-sm">Mes services</p>

                          <div className="w-full flex justify-around flex-wrap">
                            {item.matchedServices.map((service, index) =>
                              service ? (
                                <img
                                  key={index}
                                  className="h-16 w-16"
                                  src={`${"/servicesDuNomade-besoinsDuRésident/" + service + ".png"}`}
                                  alt="service"
                                  onClick={() => handleClickToIndicateServNeedName(service)}
                                />
                              ) :
                                null
                            )}
                          </div>

                        </div>

                        {/*separator row  */}
                        <span className="border-t border-gray-300 block mt-1" />

                        {/* needs */}
                        <div id="div-expanded-row-needs" className="flex flex-col gap-2 items-center">

                          <p className="font-medium text-sm">Mes besoins</p>

                          <div className="w-full flex justify-around flex-wrap">
                            {item.matchedNeeds.map((need, index) =>
                              need ? (
                                <img
                                  key={index}
                                  className="h-16 w-16"
                                  src={`${"/besoinsDuNomade-servicesDuRésident/" + need + ".png"}`}
                                  alt="need"
                                  onClick={() => handleClickToIndicateServNeedName(need)}
                                />
                              ) :
                                null
                            )}
                          </div>

                        </div>

                        {/*separator row  */}
                        <span className="border-t border-gray-300 block mt-1" />

                        {/*start and end date  */}
                        <div id="div-date-expanded-row" className="font-medium flex justify-center">{`Du ${item?.start_time}`} au {`${item?.end_time}`}</div>
                      </div>

                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))
            }

            {/* exchange element of res */}
            {exchangeElementslistOfRes?.map((item, index) => (
              <React.Fragment key={index}>
                <tr className={`text-black border-b-2 ${windowWidth >= 1000 ? 'hover:cursor-default' : " hover:cursor-pointer"} hover:bg-gradient-to-b hover:from-gray-200 hover:to-gray-100`} onClick={() => { handleExpandedRow(index) }}>

                  {/* title and pastille */}
                  <td id="td-tilte-pastille-r" className="text-center">
                    <div id="div-title-pastille-r" className="flex items-center justify-between">

                      {/* pastille green or red */}
                      {item.isAvailable === true ? (
                        <div className="rounded-full w-4 h-4 bg-greenCustom" title="Disponible"></div>
                      ) : <div className="rounded-full w-4 h-4 bg-lightRedCustom" title="Indisponible"></div>
                      }

                      <div className="flex-grow pl-2">
                        {item.title}
                      </div>
                    </div>
                  </td>

                  {/* services */}
                  <td id="td-services" className="p-2">
                    <div className="flex gap-2 justify-center flex-wrap">
                      {item.matchedServices.map((service, index) =>
                        service ? (
                          <img
                            key={index}
                            className="h-16 w-16"
                            src={`${"/besoinsDuNomade-servicesDuRésident/" + service + ".png"}`}
                            alt="service"
                            onClick={() => handleClickToIndicateServNeedName(service)}
                          />
                        ) :
                          null
                      )}
                    </div>
                  </td>

                  {/* needs */}
                  <td id="td-needs">
                    <div className="flex justify-center gap-2 flex-wrap">
                      {item.matchedNeeds.map((need, index) =>
                        need ? (
                          <img
                            key={index}
                            className="h-16 w-16"
                            src={`${"/servicesDuNomade-besoinsDuRésident/" + need + ".png"}`}
                            alt="need"
                            onClick={() => handleClickToIndicateServNeedName(need)}
                          />
                        ) :
                          null
                      )}
                    </div>
                  </td>

                  {/* date */}
                  <td id="start-end-date-time" className="text-center font-normal">
                    {`Du ${item.start_time}`}
                    <br />
                    au
                    <br />
                    {`${item.end_time}`}
                  </td>

                  {/* actions and pastille */}
                  <td id="td-actions" className="text-center max-w-24 max-h-24 w-28">

                    <div id="container-icon-actions" className="w-full h-full">

                      {/* btn edit or delete */}
                      {item.isAvailable && item.is_subject_of_proposal === false ? (
                        <EditTroc userRole={userRole} troc={item} triggerUseffect2={triggerUseEffect2} setTriggerUseEffect2={setTriggerUseEffect2} />
                      ) : <button type="button" className="flex justify-center px-4 py-2 text-gray-700 hover:bg-gray-100" onClick={() => handleRemovingTroc(item.id)}>
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                      }

                    </div>

                  </td>

                </tr>

                {/* in mobile release: expanded row */}
                {/* part expanded row */}
                {expandedRowIndex === index && (
                  <tr id="tr-expanded-row-rlse-mob" className="hover:bg-gray-200 text-black border-b-2 ">
                    <td id="dynamic-td" colSpan={colspan}>

                      <div id="div-services-needs" className="flex flex-col gap-2">

                        {/* services */}
                        <div id="div-expanded-row-services" className="flex flex-col gap-2 items-center">

                          <p className="font-medium text-sm">Mes services</p>

                          <div className="w-full flex justify-around flex-wrap">
                            {item.matchedServices.map((service, index) =>
                              service ? (
                                <img
                                  key={index}
                                  className="h-16 w-16"
                                  src={`${"/besoinsDuNomade-servicesDuRésident/" + service + ".png"}`}
                                  alt="service"
                                  onClick={() => handleClickToIndicateServNeedName(service)}
                                />
                              ) :
                                null
                            )}
                          </div>

                        </div>

                        {/*separator row  */}
                        <span className="border-t border-gray-300 block mt-1" />

                        {/* needs */}
                        <div id="div-expanded-row-needs" className="flex flex-col gap-2 items-center">

                          <p className="font-medium text-sm">Mes besoins</p>

                          <div className="w-full flex justify-around flex-wrap">
                            {item.matchedNeeds.map((need, index) =>
                              need ? (
                                <img
                                  key={index}
                                  className="h-16 w-16"
                                  src={`${"/servicesDuNomade-besoinsDuRésident/" + need + ".png"}`}
                                  alt="need"
                                  onClick={() => handleClickToIndicateServNeedName(need)}
                                />
                              ) :
                                null
                            )}
                          </div>

                        </div>

                        {/*separator row  */}
                        <span className="border-t border-gray-300 block mt-1" />

                        {/*start and end date  */}
                        <div id="div-date-expanded-row" className="font-medium flex justify-center">{`Du ${item?.start_time}`} au {`${item?.end_time}`}</div>
                      </div>

                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))
            }
          </tbody>

        </Table>

        {/* Fenêtre modale */}
        {isIndicateServiceNeedName && <IndicateServiceNeedName name={serviceNeedName} setisIndicateServiceNeedName={setisIndicateServiceNeedName} />}
      </div>
    </>
  )
}